module.exports = __webpack_public_path__ + "static/media/map-pin.9ba83c29.svg";